import React, { useState, useEffect } from 'react'
import LandingPage from './components/LandingPage'
import GameScreen from './components/GameScreen'

export default function App() {
  const [screen, setScreen] = useState('landing') // 'landing' | 'game'
  const [gameConfig, setGameConfig] = useState({
    mode: '1p',
    topic: 'mix',
    difficulty: 'medium',
  })

  // Parse URL search parameters on initial load
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const mode = params.get('mode')
    const topic = params.get('topic')
    const difficulty = params.get('difficulty')

    if (mode === '1p' || mode === '2p') {
      setGameConfig({
        mode,
        topic: topic === 'hrm' || topic === 'krn' ? topic : 'mix',
        difficulty: difficulty === 'easy' || difficulty === 'hard' ? difficulty : 'medium',
      })
      setScreen('game')
    }
  }, [])

  const handleStartGame = (config) => {
    setGameConfig(config)
    // Update URL query parameters without reloading
    const newUrl = `${window.location.pathname}?mode=${config.mode}&topic=${config.topic}&difficulty=${config.difficulty}`
    window.history.pushState({ path: newUrl }, '', newUrl)
    setScreen('game')
  }

  const handleBackToHome = () => {
    // Clear URL query parameters
    window.history.pushState({}, '', window.location.pathname)
    setScreen('landing')
  }

  return (
    <div className="w-full min-h-screen bg-[#0a0015] text-white overflow-hidden">
      {screen === 'landing' ? (
        <LandingPage onSelectGame={handleStartGame} />
      ) : (
        <GameScreen
          mode={gameConfig.mode}
          topic={gameConfig.topic}
          difficulty={gameConfig.difficulty}
          onBackToHome={handleBackToHome}
        />
      )}
    </div>
  )
}
